<!--

  Implementation

  -in template:
    <preview-header :title="title"
                    :loading="!loaded">
    </preview-header>

  -import:
    import PreviewHeader from "@/components/SingleUse/PreviewHeader.vue";

-->
<template>
  <v-app-bar dense
             elevation="0"
             class="d-flex justify-center listheader"
             height="unset">
    <h2 class="mb-1 pt-4"
        :class="loading ? 'blurred' : ''"
        v-text="title ? title : 'No title'" />
  </v-app-bar>
</template>


<script>
export default {
  name: "PreviewHeader",
  props: ["title", "loading"],

  methods: {},
};
</script>


<style lang="scss" scoped>
.listheader {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: rgba(249, 249, 249, 0.713) !important;
}
</style>